import { render } from "./MoveItems.vue?vue&type=template&id=3f2bd7e4"
import script from "./MoveItems.vue?vue&type=script&lang=js"
export * from "./MoveItems.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__